<div id="end-page-view__container" class="end-page-view__container">
  <empathy-viewer-template-card [noHeader]="true">
    <div slot="details" class="end-page-view__container__content">
      @if (terminateQuestion) {
        <div class="fs__lg fw__600" [innerHTML]="terminateQuestion.title"></div>
        <div [innerHTML]="terminateQuestion.description"></div>
      } @else {
        <div class="fs__lg" [innerHTML]="surveyModel.endPageHtml"></div>
      }
    </div>
  </empathy-viewer-template-card>
</div>

<div class="end-page-view__footer">
  <empathy-viewer-progress-bar [progress]="100"></empathy-viewer-progress-bar>
  <mat-toolbar class="end-page-view__footer__toolbar">
    <empathy-viewer-button [text]="surveyModel.endButtonText || 'Complete'" [loadingText]="'Sending...'" (clicked)="completed.emit()"></empathy-viewer-button>
  </mat-toolbar>
</div>
